import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';






import {NavbarModule} from 'app/layout/components/navbar/navbar.module';

import {AjudaPanelModule} from 'app/layout/components/ajuda-panel/ajuda-panel.module';
import {ToolbarModule} from 'app/layout/components/toolbar/toolbar.module';

import {VerticalLayout1Component} from './layout-1.component';
import {ChatPanelModule} from '../../components/chat-panel/chat-panel.module';

import {CdkMediaWatcherService} from '../../../../@cdk/utils/media-watcher.service';

@NgModule({
    imports: [
    RouterModule,
    NavbarModule,
    AjudaPanelModule,
    ChatPanelModule,
    ToolbarModule,
    VerticalLayout1Component
],
    providers: [
        CdkMediaWatcherService
    ],
    exports: [
        VerticalLayout1Component
    ]
})
export class VerticalLayout1Module {
}
